import useProductStore from '@/stores/productStore';

const ReviewPaymentMethods = () => {
  const currentPaymentMethod = useProductStore(d => d.payment);

  if (!('methods' in currentPaymentMethod)) {
    return null;
  }

  return (
    <div className='flex flex-col'>
      {currentPaymentMethod.methods?.some(method => method.type === 'credit_card') && <span>Cartão de Crédito</span>}
      {currentPaymentMethod.methods?.some(method => method.type === 'pix') && <span>Pix</span>}
      {currentPaymentMethod.methods?.some(method => method.type === 'bankslip') && <span>Boleto</span>}
    </div>
  );
};

export default ReviewPaymentMethods;
